module.exports = __webpack_public_path__ + "img/优秀学员认定奖杯内容.b9db7634.png";